module.exports = require("memoizee");


//////////////////
// WEBPACK FOOTER
// external "memoizee"
// module id = 480
// module chunks = 0